// Portado de src/pages/saude-com-proposito.astro (site Astro).
import { useAgendamentoLink } from "@/lib/itv/agendamento";
import { CardsAtendimento } from "@/components/itv/CardsAtendimento";

// Rotulos do radar do hero (Figma 159:9 a 159:22). Coordenadas do frame de 1440x732.
// x/y = centro do ponto; lx/ly = canto superior esquerdo do rotulo.
const radar = [
  { rotulo: "ALIMENTAÇÃO", x: 1015.5, y: 126.5, lx: 985, ly: 109 },
  { rotulo: "EXERCÍCIO E MÚSCULO", x: 1250.05, y: 239.45, lx: 1268.55, ly: 238.95 },
  { rotulo: "SONO", x: 1307.98, y: 493.26, lx: 1326.48, ly: 492.76 },
  { rotulo: "METABÓLICO-HORMONAL", x: 1145.67, y: 696.79, lx: 1164.17, ly: 696.29 },
  { rotulo: "SUPLEMENTAÇÃO", x: 885.33, y: 696.79, lx: 792.83, ly: 696.29 },
  { rotulo: "SAÚDE EMOCIONAL", x: 723.02, y: 493.26, lx: 617.52, ly: 492.76 },
  { rotulo: "ESPIRITUALIDADE", x: 780.95, y: 239.45, lx: 675.45, ly: 238.95 },
];

// Aneis concentricos do hero (Figma 159:2 a 159:6), do menor para o maior.
const aneis = [
  { src: "/icones/anel-1.svg", tamanho: 200, x: 920, y: 331 },
  { src: "/img/anel-brilho.webp", tamanho: 400, x: 820, y: 231 },
  { src: "/icones/anel-2.svg", tamanho: 600, x: 720, y: 131 },
  { src: "/icones/anel-3.svg", tamanho: 840, x: 600, y: 11 },
  { src: "/icones/anel-4.svg", tamanho: 1120, x: 460, y: -129 },
];

// Os sete pilares.
const pilares = [
  {
    numero: "01",
    titulo: "Alimentação",
    texto:
      "Uma estratégia alimentar adequada às suas necessidades, objetivos e rotina, não uma dieta temporária. Pode ser direcionada para emagrecimento, composição corporal, massa muscular, performance ou longevidade. Uma alimentação saudável é reconhecida como um dos fundamentos para saúde e prevenção de doenças crônicas. (Organização Mundial da Saúde)",
  },
  {
    numero: "02",
    titulo: "Exercício físico e massa muscular",
    texto:
      "Movimento é parte do tratamento e da prevenção, não apenas uma forma de gastar caloria. O exercício entra como estratégia para força, massa muscular, capacidade cardiorrespiratória, metabolismo e funcionalidade. A massa muscular recebe atenção especial, porque a ideia é envelhecer mantendo independência e capacidade física. A atividade física regular está associada à prevenção de doenças crônicas e à melhora da saúde mental e do bem-estar. (Organização Mundial da Saúde)",
  },
  {
    numero: "03",
    titulo: "Sono e recuperação",
    texto:
      "Não existe saúde plena quando o organismo não consegue se recuperar. Avaliamos quantidade e qualidade do sono, rotina, recuperação física, estresse e o que interfere no descanso. O sono também pesa quando o assunto é emagrecimento, disposição, desempenho físico e qualidade de vida.",
  },
  {
    numero: "04",
    titulo: "Saúde metabólica e hormonal",
    texto:
      "A avaliação é individualizada, com história clínica, exame físico e exames complementares quando necessários. Investigamos metabolismo, resistência insulínica, composição corporal, deficiências nutricionais e alterações hormonais. Havendo indicação médica, podem entrar estratégias medicamentosas, suplementação ou tratamento hormonal. O objetivo não é otimizar números, e sim tratar o que tem indicação clínica, acompanhando segurança e resposta.",
  },
  {
    numero: "05",
    titulo: "Suplementação e estratégias",
    texto:
      "Suplementos, medicamentos e outras estratégias podem fazer parte do tratamento, mas não são a base do método e não substituem hábitos de vida. Quando indicados, são usados de maneira individualizada, considerando história clínica, exames, objetivos, evidências disponíveis e a relação entre risco e benefício. O tratamento serve ao paciente, e não o contrário.",
  },
  {
    numero: "06",
    titulo: "Saúde emocional e equilíbrio",
    texto:
      "Corpo e mente não funcionam separadamente. Estresse crônico, ansiedade, rotina excessiva, relacionamentos e falta de descanso repercutem nos hábitos e na qualidade de vida. Por isso procuramos compreender o contexto em que você vive e identificar o que dificulta a adesão e a saúde como um todo.",
  },
  {
    numero: "07",
    titulo: "Espiritualidade e propósito",
    texto:
      "Este é um dos grandes diferenciais conceituais do método. Saúde não deve ser um fim em si mesma: queremos saúde para alguma coisa. Para cuidar da família, para trabalhar, para servir, para acompanhar os filhos e, um dia, os netos. A espiritualidade pode fazer parte dessa compreensão, sempre respeitando os valores, as crenças e a individualidade de cada paciente.",
  },
];

export function SaudeComProposito() {
  const agendar = useAgendamentoLink();
  return (
    <div className="pag-metodo">
      {/* hero-manifesto — Figma 119:14 */}
      <section className="hero">
        <div className="container hero-conteudo">
          <nav className="trilha" aria-label="Você está em">
            <a href="/">Home</a> <span aria-hidden="true">›</span> <span>Método SP</span>
          </nav>
          <p className="hero-sobretitulo">MÉTODO SP · A FORMA DE CUIDAR DO DR. THIAGO VIANA</p>
          <h1>
            Saúde com
            <br />
            <em>Propósito.</em>
          </h1>
          <p className="hero-chamada">
            O Método SP nasceu de uma convicção simples: saúde não deve ser o objetivo final. Ela é uma
            ferramenta para que você possa viver plenamente o seu propósito.
          </p>
          <div className="hero-botoes">
            <a className="btn-ouro hero-btn" href={agendar}>
              Agendar consulta
            </a>
            <a className="btn-fantasma" href="#pilares">
              conhecer os sete pilares
            </a>
          </div>
        </div>

        <div className="radar" aria-hidden="true">
          {aneis.map((a) => (
            <img
              key={a.src}
              className="radar-anel"
              src={a.src}
              width={a.tamanho}
              height={a.tamanho}
              alt=""
              loading="lazy"
              style={{ left: `${a.x}px`, top: `${a.y}px`, width: `${a.tamanho}px`, height: `${a.tamanho}px` }}
            />
          ))}
          <img className="radar-teia" src="/icones/radar-chart.svg" width={525} height={420} alt="" loading="lazy" />
          <p className="radar-centro">propósito.</p>
          <p className="radar-centro-rotulo">O CENTRO DO MÉTODO</p>
          {radar.map((r) => (
            <span key={r.rotulo}>
              <img
                className="radar-ponto"
                src="/icones/ponto.svg"
                width={47}
                height={47}
                alt=""
                loading="lazy"
                style={{ left: `${r.x - 19}px`, top: `${r.y - 19}px` }}
              />
              <p className="radar-rotulo" style={{ left: `${r.lx}px`, top: `${r.ly}px` }}>
                {r.rotulo}
              </p>
            </span>
          ))}
        </div>
      </section>

      {/* o-que-e — Figma 120:2 */}
      <section className="o-que-e">
        <div className="container o-que-e-grade">
          <div className="o-que-e-statement">
            <p className="sobretitulo">O QUE É</p>
            <h2>
              Uma forma de enxergar a saúde <em>ampla, individualizada e integrada</em>.
            </h2>
          </div>
          <div className="o-que-e-colunas">
            <p>
              No Método SP, você não é avaliado por uma queixa isolada. Procuramos entender como você se
              alimenta, como se movimenta, como dorme, como estão seu metabolismo, sua composição
              corporal, seus hormônios quando pertinente, sua saúde emocional, sua rotina e seu
              propósito de vida.
            </p>
            <p>
              Não existe uma estratégia igual para todos. Cada paciente tem uma história, uma rotina,
              objetivos e limitações diferentes. O plano de cuidado busca não apenas melhorar exames ou
              composição corporal, mas promover energia, força, funcionalidade, prevenção e longevidade.
            </p>
          </div>
        </div>
      </section>

      {/* pilares — Figma 120:20 */}
      <section className="pilares" id="pilares">
        <div className="container">
          <div className="pilares-titulo">
            <p className="sobretitulo">OS SETE PILARES</p>
            <h2>O método, pilar a pilar</h2>
            <p className="pilares-chamada">
              A avaliação identifica quais pilares precisam de mais atenção no seu caso. A estratégia
              nasce daí, para ser sustentada ao longo do tempo.
            </p>
          </div>

          <div className="pilares-linhas">
            {pilares.map((p, i) => (
              <details className="pilar" open={i === 0} key={p.numero}>
                <summary>
                  <span className="pilar-numero">{p.numero}</span>
                  <h3>{p.titulo}</h3>
                  <span className="pilar-sinal" aria-hidden="true" />
                </summary>
                <div className="pilar-corpo">
                  <p>{p.texto}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* anafora — Figma 120:9 */}
      <section className="anafora">
        <div className="anafora-halos" aria-hidden="true">
          <img src="/icones/halo-3.svg" width={1300} height={1300} alt="" loading="lazy" style={{ left: "-710px", top: "-370px" }} />
          <img src="/icones/halo-2.svg" width={900} height={900} alt="" loading="lazy" style={{ left: "-510px", top: "-170px" }} />
          <img src="/icones/halo-1.svg" width={500} height={500} alt="" loading="lazy" style={{ left: "-310px", top: "30px" }} />
        </div>
        <div className="container anafora-texto">
          <h2 className="anafora-eyebrow">QUEREMOS SAÚDE PARA ALGUMA COISA</h2>
          <p className="anafora-linha">
            Saúde para cuidar da <em>família.</em>
          </p>
          <p className="anafora-linha">
            Saúde para <em>trabalhar.</em>
          </p>
          <p className="anafora-linha">
            Saúde para <em>servir.</em>
          </p>
          <p className="anafora-linha">
            Saúde para acompanhar os filhos e, um dia, <em>os netos.</em>
          </p>
          <p className="anafora-nota">
            A espiritualidade pode fazer parte dessa compreensão de saúde, sempre respeitando os
            valores, as crenças e a individualidade de cada paciente.
          </p>
        </div>
      </section>

      {/* conexao — Figma 121:2 */}
      <section className="conexao">
        <div className="container conexao-inner">
          <p className="sobretitulo">A CONEXÃO ENTRE OS PILARES</p>
          <h2>
            O diferencial está na <em>integração</em>
          </h2>

          <div className="conexao-tres">
            <p>
              Não adianta pensar em <em>emagrecimento</em> se o paciente dorme mal.
            </p>
            <p>
              Não basta olhar para <em>hormônios</em> se alimentação e exercício estão inadequados.
            </p>
            <p>
              Não faz sentido buscar <em>longevidade</em> sem preservar massa muscular.
            </p>
          </div>

          <blockquote className="conexao-citacao">
            <p>
              «Nosso objetivo não é acrescentar anos à vida. É construir saúde para que exista{" "}
              <em>vida nos anos.</em>»
            </p>
            <cite>DR. THIAGO VIANA</cite>
          </blockquote>
        </div>
      </section>

      {/* na-pratica — Figma 121:16 */}
      <section className="na-pratica">
        <div className="container na-pratica-inner">
          <p className="na-pratica-eyebrow">NA PRÁTICA</p>
          <h2>
            O método começa pela <em>Avaliação 360°</em>
          </h2>
          <p className="na-pratica-chamada">
            A consulta que percorre os sete pilares: composição corporal com bioimpedância inclusa,
            metabolismo, alimentação, sono, hormônios, exames e rotina. É a porta de entrada do
            consultório.
          </p>
          <CardsAtendimento />
        </div>
      </section>
    </div>
  );
}
